module.exports = __webpack_public_path__ + "img/stack-overflow-orange.b62ff2fa.png";